export const getEnvUrl = () => {
  const currentUrl = window.location.href;
  const prodUrl = process.env.REACT_APP_VOERY_PROD_URL;

  const isProd = currentUrl.startsWith(prodUrl) && !currentUrl.includes('stage');

  const apiBaseUrl = isProd
    ? process.env.REACT_APP_API_VOERY_BASE_URL_PROD
    : process.env.REACT_APP_API_VOERY_BASE_URL_STAGE;

  // const s3BaseUrl = isProd
  //   ? 'https://foodzeebucket.s3.eu-central-1.amazonaws.com/media/'
  //   : 'https://foodzee-stage.s3.eu-central-1.amazonaws.com/media/';

  return {
    isProd,
    apiBaseUrl,
    // s3BaseUrl,
  };
};
